import request from "./request";
let mainUrls="/camera/doCrmApiInvoke"
let urlStart="https://api-p05.xiaoshouyi.com"


// 注册页面获取验证码
let codeUrl = urlStart+"/rest/data/v2.0/scripts/api/neocrm/getVerificationCode";
export function getVerificationCode(data) {
    return request({
        url:mainUrls,
        method:"post",
        data:{url: codeUrl,
        method: 'post',
        jsonBody:data}
    })
}
// 重置密码页面获取验证码
let codeUrlRe = urlStart+"/rest/data/v2.0/scripts/api/neocrm/getResetVerificationCode";
export function getVerificationCodeRe(data) {
    return request({
        url:mainUrls,
        method:"post",
        data:{url: codeUrlRe,
        method: 'post',
        jsonBody:data}
    })
}
//注册
let registeredUrl=urlStart+'/rest/data/v2.0/scripts/api/neocrm/registered'
export function registered(data){
    return request({
        url:mainUrls,
        method:"post",
        data:{url: registeredUrl,
        method: 'post',
        jsonBody:data}
    })
}
//登录
let loginUrl=urlStart+'/rest/data/v2.0/scripts/api/neocrm/login'
export function login(data) {
    return request({
        url:mainUrls,
        method:"post",
        data:{url: loginUrl,
        method: 'post',
        jsonBody:data}
    })
}
//重置密码
let resetPassUrl=urlStart+'/rest/data/v2.0/scripts/api/neocrm/resetPassword'
export function resetPas(data) {
    return request({
        url:mainUrls,
        method:"post",
        data:{url: resetPassUrl,
        method: 'post',
        jsonBody:data}
    })
}
//知识条目分类
let categoryUrl=urlStart+'/rest/data/v2.0/xobjects/serviceKnowledge/actions/getCatalogList'
export function getCats() {
    return request({
        url:mainUrls,
        method:"post",
        data:{url: categoryUrl,
            email:sessionStorage.getItem('email'),
        method: 'get'}
    })
}
//知识条目
let knowledgeUrl=urlStart+'/rest/data/v2/query?q=select id,name,knowledgeContent,similarQues,knowledgeNo,classify,parentCatalogName,createdAt from serviceKnowledge where isExternalPublic=1 and knowledgeStatus=2'
export function getKnowledge(email) {
    return request({
        url:mainUrls,
        method:"post",
        // data:{
        // url: knowledgeUrl,
        // method: 'get'}
        data:{
            url: urlStart+'/rest/data/v2.0/scripts/api/neocrm/knowledgeQuerry',
            method: 'post',
            "jsonBody": {
               // 'email':email
               'email':sessionStorage.getItem('email')
            }
        }
    })
}

//工单列表
//let caseListUrl='/rest/data/v2/query?q=select id,name,caseNo,caseStatus,createdAt,SVCStartTime__c from serviceCase'
// export function getCaseList(pageSize,pageNum,id) {
// export function getCaseList(id) {
//     return request({
//         // url: caseListUrl + ' where caseAccountId='+id+' limit '+(pageNum - 1)*pageSize +','+pageSize,
//         url: caseListUrl + ' where caseAccountId='+id+' limit 0,3000',
//         method: 'get'
//     })
// }
let caseListUrl=urlStart+'/rest/data/v2.0/scripts/api/neocrm/querryService'
export function getCaseList(id,str,email) {
    let timeStamp=new Date().getTime()
    //let param = new URLSearchParams();
    // if(str){
    //     let b=str+'%'
    //     param.append("xoql", "select id,name,caseNo,caseStatus,createdAt,SVCStartTime__c from serviceCase where caseAccountId="+id+" and (name like '"+b +"' or caseNo like '"+b+"')");
    // }else{
    //     param.append("xoql", "select id,name,caseNo,caseStatus,createdAt,SVCStartTime__c from serviceCase where caseAccountId="+id);
    // }
    // param.append("useSimpleCode",true);
    let qstr=""
    if(str){
        let b=str+'%'
        qstr="select id,name,caseNo,caseStatus,createdAt,SVCStartTime__c from serviceCase where caseAccountId="+id+" and (name like '"+b +"' or caseNo like '"+b+"')"
    }else{
        qstr="select id,name,caseNo,caseStatus,createdAt,SVCStartTime__c from serviceCase where caseAccountId="+id
    }
    return request({
        // url: caseListUrl + ' where caseAccountId='+id+' limit '+(pageNum - 1)*pageSize +','+pageSize,
        url:mainUrls,
        method:"post",
        data:{
        url: caseListUrl,
        method: 'post',
        "jsonBody": {
            "name": str,
            "caseAccountId": id,
           // 'email':email
           'email':sessionStorage.getItem('email')
        }
       // "form-data":{xoql:qstr}
        }
    })
}
//创建工单
let caseUrl=urlStart+'/rest/data/v2.0/xobjects/serviceCase'
export function createCase(data) {
    return request({
        url:mainUrls,
        method:"post",
        data:{url: caseUrl,
        method: 'post',
        jsonBody:{email:sessionStorage.getItem('email'),data}}
    })
}
//查询工单详情
export function getCaseDetail(id) {
    return request({
        url:mainUrls,
        method:"post",
        data:{url: caseUrl+'/'+id,
        email:sessionStorage.getItem('email'),
        method: 'get'}
    })
}
//创建活动记录
let activityrecord=urlStart+'/rest/data/v2.0/xobjects/activityrecord'
export function createRecord(data) {
    return request({
        url:mainUrls,
        method:"post",
        data:{
            url: activityrecord,
        method: 'post',
        jsonBody:{email:sessionStorage.getItem('email'),data}
    }
    })
}
//查询活动记录
export function getRecord(id,email) {
    return request({
        url:mainUrls,
        method:"post",
        data:{url: urlStart+'/rest/data/v2.0/scripts/api/neocrm/activityrecordQuerry',
        method: 'post',
        "jsonBody": {
            "email": sessionStorage.getItem('email'),
            "activityRecordFrom_data":id
        }
    }
    })
}
//查询项目编号
export function findProject(data) {
    let projectUrl=urlStart+"/rest/data/v2/query?q=select id,name from project__c where name='"+data+"'"
    return request({
        url:mainUrls,
        method:"post",
        data:{url:urlStart+'/rest/data/v2.0/scripts/api/neocrm/projectQuerry' ,
        method: 'post',
        "jsonBody": {
            "name": data,
            "email":sessionStorage.getItem('email')
        }
       }
    })
}
//附件上传
//let fileUrl='/rest/file/v2.0/file/batch'
let aurl=window.location.protocol+"//"+window.location.host
let fileUrl=aurl+'/camera/uploadFile'
export function fileLoad(data) {
    return request({
        url:fileUrl ,
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data:data
    })
}
//图片下载
let imageLoadUrl=urlStart+'/rest/file/v2.0/file/actions/files?fileIds='
export function downLoadImages(data) {
    return request({
        url:mainUrls,
        method:"post",
        data:{url:imageLoadUrl + data+'&outType=0',
        method: 'get'}
    })
}
//知识条目模糊查询
let knowledgeUrl2=urlStart+'/rest/data/v2.0/scripts/api/neocrm/querryKnowledge'
export function searchKnowledge(data) {
    return request({
        url:mainUrls,
        method:"post",
        data:{url: knowledgeUrl2,
        method: 'post',
        jsonBody:Object.assign({email:sessionStorage.getItem('email')},data)}
    })
}